module.exports = __webpack_public_path__ + "static/img/2.1139848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star/jydbv20230320/2.png
// module id = XqYo
// module chunks = 0